export const countries: { country: string; continent: string; language: string; flag: string }[] = [
    { country: 'Ireland', continent: 'Europe', language: 'English', flag: '🇮🇪' },
    { country: 'Spain', continent: 'Europe', language: 'Spanish', flag: '🇪🇸' },
    { country: 'United Kingdom', continent: 'Europe', language: 'English', flag: '🇬🇧' },
    { country: 'France', continent: 'Europe', language: 'French', flag: '🇫🇷' },
    { country: 'Germany', continent: 'Europe', language: 'German', flag: '🇩🇪' },
    { country: 'Luxembourg', continent: 'Europe', language: 'French', flag: '🇱🇺' },
    { country: 'Sweden', continent: 'Europe', language: 'Swedish', flag: '🇸🇪' },
    { country: 'Norway', continent: 'Europe', language: 'Norwegian', flag: '🇳🇴' },
    { country: 'Italy', continent: 'Europe', language: 'Italian', flag: '🇮🇹' },
    { country: 'Greece', continent: 'Europe', language: 'Greek', flag: '🇬🇷' },
    { country: 'Iceland', continent: 'Europe', language: 'Icelandic', flag: '🇮🇸' },
    { country: 'Portugal', continent: 'Europe', language: 'Portuguese', flag: '🇵🇹' },
    { country: 'Malta', continent: 'Europe', language: 'Maltese', flag: '🇲🇹' },
    { country: 'Brazil', continent: 'South America', language: 'Portuguese', flag: '🇧🇷' },
    { country: 'Argentina', continent: 'South America', language: 'Spanish', flag: '🇦🇷' },
    { country: 'Colombia', continent: 'South America', language: 'Spanish', flag: '🇨🇴' },
    { country: 'Peru', continent: 'South America', language: 'Spanish', flag: '🇵🇪' },
    { country: 'Venezuela', continent: 'South America', language: 'Spanish', flag: '🇻🇪' },
    { country: 'Uruguay', continent: 'South America', language: 'Spanish', flag: '🇺🇾' },
    { country: 'Belgium', continent: 'Europe', language: 'French', flag: '🇧🇪' },
    { country: 'Vietnam', continent: 'Asia', language: 'Vietnamese', flag: '🇻🇳' },
    { country: 'Japan', continent: 'Asia', language: 'Japanese', flag: '🇯🇵' },
    { country: 'China', continent: 'Asia', language: 'Chinese', flag: '🇨🇳' },
    { country: 'South Korea', continent: 'Asia', language: 'Korean', flag: '🇰🇷' },
    { country: 'Philippines', continent: 'Asia', language: 'Filipino', flag: '🇵🇭' },
    { country: 'Malaysia', continent: 'Asia', language: 'Malay', flag: '🇲🇾' },
];

export const firstNames = [
    'Tony',
    'Andrew',
    'Kevin',
    'Bricker',
    'Dimple',
    'Gil',
    'Sophie',
    'Isabelle',
    'Emily',
    'Olivia',
    'Lily',
    'Chloe',
    'Isabella',
    'Amelia',
    'Jessica',
    'Sophia',
    'Ava',
    'Charlotte',
    'Mia',
    'Lucy',
    'Grace',
    'Ruby',
    'Ella',
    'Evie',
    'Freya',
    'Isla',
    'Poppy',
    'Daisy',
    'Layla',
    'Shizuko',
    'Sung',
    'Yosuke',
    'Jingyi',
    'Midori',
    'Hyun',
];

export const lastNames = [
    'Smith',
    'Connell',
    'Flanagan',
    'McGee',
    'Unalkat',
    'Lopes',
    'Beckham',
    'Black',
    'Braxton',
    'Brennan',
    'Brock',
    'Bryson',
    'Cadwell',
    'Cage',
    'Carson',
    'Chandler',
    'Cohen',
    'Cole',
    'Corbin',
    'Dallas',
    'Dalton',
    'Dane',
    'Donovan',
    'Easton',
    'Fisher',
    'Fletcher',
    'Grady',
    'Greyson',
    'Griffin',
    'Gunner',
    'Hayden',
    'Hudson',
    'Hunter',
    'Jacoby',
    'Jagger',
    'Jaxon',
    'Jett',
    'Kade',
    'Kane',
    'Keating',
    'Keegan',
    'Kingston',
    'Kobe',
    'Lan',
    'Chen',
    'Abe',
    'Thanh',
    'Ning',
    'Xuan',
    'Song',
];

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const CATEGORIES = {
    Grains: {
        icon: 'Corn',
        products: [
            'Corn',
            'Oats',
            'Rough Rice',
            'Soybeans',
            'No 2. Soybean',
            'Rapeseed',
            'Soybean Meal',
            'Soy Meal',
            'Soybean Oil',
            'Wheat',
        ],
    },
    'Textile Fibers': {
        icon: 'WatsonHealthHangingProtocol',
        products: [
            'Cotton No.2',
            'Industrial Hemp',
            'Raw Flax Fiber',
            'Silk',
            'Wool',
            'Leather',
            'Goose Down',
            'Alpaca',
        ],
    },
    'Food & Drink': {
        icon: 'Restaurant',
        products: [
            'Milk',
            'Matcha',
            'Cocoa',
            'Coffee C',
            'Sugar No.11',
            'Sugar No.14',
            'Frozen Concentrated Orange Juice',
            'Adzuki Bean',
            'Robusta Coffee',
        ],
    },
    'Syntetic fabrics': {
        icon: 'HybridNetworkingAlt',
        products: ['Nylon', 'Modacrylic', 'Olefin', 'Acrylic', 'Polyester', 'Rayon', 'Vinyon', 'Saran', 'Spandex'],
    },
    Fertilisers: {
        icon: 'CropGrowth',
        products: ['Nitrogen Fertiliser', 'Potassium Fertiliser', 'Phosphorus Fertiliser'],
    },
    'Lumber Products': {
        icon: 'Cube',
        products: ['Random Length Lumber', 'Hardwood Pulp', 'Softwood Pulp'],
    },
    'Livestock and Meat': {
        icon: 'PiggyBank',
        products: ['Lean Hogs', 'Live Cattle', 'Feeder Cattle'],
    },
    Energy: {
        icon: 'FlashFilled',
        products: [
            'Commodity',
            'WTI Crude Oil',
            'Brent Crude',
            'Ethanol',
            'Natural Gas',
            'Heating Oil',
            'Gulf Coast Gasoline',
            'RBOB Gasoline',
            'Propane',
            'Purified Terephthalic Acid (PTA)',
        ],
    },
    'Industrial Metals': {
        icon: 'ChartRadial',
        products: [
            'LME Copper',
            'Lead',
            'Zinc',
            'Tin',
            'Aluminium',
            'Aluminium Alloy',
            'LME Nickel',
            'Cobalt',
            'Molybdenum',
        ],
    },
    'Precious Metals': {
        icon: 'ChartSpiral',
        products: ['Gold', 'Platinum', 'Palladium', 'Silver'],
    },
    'Construction Products': {
        icon: 'BuildingInsights_3',
        products: [
            'Nonmetallic Mineral Products',
            'Concrete Ingredients',
            'Construction Sand',
            'Crushed and Broken Stone',
            'Cement',
            'Clay Construction',
            'Brick and Structural Clay Tile',
            'Ceramic Floor and Wall Tile',
            'Asphalt Felts and Coatings',
            'Gypsum Products',
            'Insulation Materials',
            'Paving Mixtures and Blocks',
            'Cut Stone and Stone Products',
            'Gaskets, Packing, and Sealing Devices',
        ],
    },
    Plastics: {
        icon: 'Chemistry',
        products: [
            'Acrylonitrile Butadiene Styrene',
            'Polyamides',
            'Polycarbonates',
            'Polyetherimide',
            'Polyetherketoneketone',
            'Polyetherketones',
            'Polyketone',
            'Polyethylene Terephthalate',
            'Polyimides',
            'Polyoxymethylene Plastic',
            'Polyphenylene Oxide',
            'Polysulphone',
            'Polytetrafluoroethylene',
            'Polymethyl Methacrylate',
        ],
    },
};

export const PORTFOLIOS = ['Income', 'Hybrid', 'Speculative', 'Aggressive', 'Defensive'];
